export const KAKAO_CHAT_URL = "http://pf.kakao.com/_Qvmhxj/chat";
export const KAKAO_CHAT_WINDOW_NAME = "kakaoChat";
export const KAKAO_CHAT_WINDOW_FEATURES = "width=520,height=720,noopener";

export const openKakaoChat = () => {
  window.open(
    KAKAO_CHAT_URL,
    KAKAO_CHAT_WINDOW_NAME,
    KAKAO_CHAT_WINDOW_FEATURES
  );
};
